import { DoneOutline, Info } from "@mui/icons-material";
import { Divider } from "@mui/material";
import React from "react";
import * as msg from "utils/constants/messages";

const SpamAlert = (props) => {
    return <>
        <div className="block-save">
            <Info style={{ color: "var(--hti-magenta)" }} />
            <div>{msg.spam_warning_message}</div>
        </div>
        <Divider />

        <div
            className="icon-text"
            style={{ justifyContent: "center", marginTop: "10px" }}
        >
            <button
                className="apply-button"
                style={{ width: "max-content", marginRight: "0px" }}
                onClick={props.handleSubmit}
            >
                <p className="apply-button-text">OK</p>
            </button>
        </div>
    </>
}

export default SpamAlert;